var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgCross2 = function SvgSvgCross2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.25 23.999a.74.74 0 0 1-.53-.22L12 13.06 1.28 23.779a.744.744 0 0 1-1.06 0 .75.75 0 0 1 0-1.061l10.72-10.72L.22 1.279A.74.74 0 0 1 0 .749c0-.2.078-.389.22-.53a.74.74 0 0 1 .53-.22c.2 0 .389.078.53.22L12 10.938 22.72.218a.744.744 0 0 1 1.06 0 .747.747 0 0 1 0 1.061l-10.72 10.72 10.72 10.72a.75.75 0 0 1 0 1.061.75.75 0 0 1-.53.219"
  })));
};
export default SvgSvgCross2;